import React from "react";
import Nav from './components/nav/Nav';
import  Header from './components/header/Header';
import About from './components/about/About';
import Contact from './components/contact/Contact';


function App() {
  return (
    <div>
      
      <Header/>
     <hr/>
     <Nav/>
     <About/>
     
     <hr/>
     <Contact/>
      

    
    </div>
  );
}

export default App;
